import AscendingDescendingNumbers from "../../components/LKG/Mathematics/AscendingDescendingNumbers";
import BeforeAfterBetweenNumbers from "../../components/LKG/Mathematics/BeforeAfterBetweenNumber";
import CountingNumbers from "../../components/LKG/Mathematics/CountingNumber";
import CountingShapes from "../../components/LKG/Mathematics/CountingShapes";
import GreaterLessThan from "../../components/LKG/Mathematics/GreaterLessThan";
import IndentifyShapes from "../../components/LKG/Mathematics/IdentifyShapes";
import MatchShapes from "../../components/LKG/Mathematics/MatchShapes";
import MissingNumber from "../../components/LKG/Mathematics/MissingNumber";
import NumberNames from "../../components/LKG/Mathematics/NumberNames";
import OrdinalNumbers from "../../components/LKG/Mathematics/OrdinalNumbers";
import Pattern from "../../components/LKG/Mathematics/Pattern";
import PreMathConcepts from "../../components/LKG/Mathematics/PreMathConcepts";
import SkipPattern from "../../components/LKG/Mathematics/SkipPattern";

import PreMathConceptsMenu from "./PreMathConcepts";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}

document.title = "Mamas Guidance - LKG - Mathematics";

const topics: MenuItem[] = [
    { url: "/lkg/mathematics/pre-math-concepts", title: "Pre Math Concepts", component: PreMathConcepts, subMenu: PreMathConceptsMenu},
    { url: "/lkg/mathematics/counting-numbers", title: "Counting Numbers", component: CountingNumbers},
    { url: "/lkg/mathematics/missing-number", title: "Missing Number", component: MissingNumber},
    { url: "/lkg/mathematics/before-after-between-number", title: "Before / After / Between Number", component: BeforeAfterBetweenNumbers},
    { url: "/lkg/mathematics/skip-number", title: "Skip Number by 2 or 5", component: SkipPattern},
    { url: "/lkg/mathematics/number-names", title: "Choose Number Names", component: NumberNames},
    { url: "/lkg/mathematics/greater-less-than", title: "Greater Than / Less Than", component: GreaterLessThan},
    { url: "/lkg/mathematics/ascending-decending-order", title: "Ascending / Decending Order", component: AscendingDescendingNumbers},
    { url: "/lkg/mathematics/identify-shapes", title: "Identify Shapes", component: IndentifyShapes},
    { url: "/lkg/mathematics/counting-shapes", title: "Counting Shapes", component: CountingShapes},
    { url: "/lkg/mathematics/match-shapes", title: "Match Shapes", component: MatchShapes },
    { url: "/lkg/mathematics/ordinal-numbers", title: "Ordinal Numbers", component: OrdinalNumbers},
    { url: "/lkg/mathematics/pattern", title: "Pattern", component: Pattern},
];


export default topics;